import React from 'react';
import {
  Box, Container, Typography, Button, Grid,
} from '@mui/material';
import { ImgBox, Typography700 } from 'views/rebranded-module/common/components';
import useAdabtiveMultiSizeImage from 'views/common/hooks/useAdabtiveMultiSizeImage';
import StyledBox from 'views/rebranded-module/deals-module/DealsViewV2/components/PromotedDealSection/PromotedDealSection.styles';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import NavigatorLink from 'views/rebranded-module/common/components/Logical/NavigatorLink';
import PATHS from 'lib/navigation/paths';

const PromotedDealSection = () => {
  const content = useContent('DealsListingPage');
  const getSizedImage = useAdabtiveMultiSizeImage();

  return (
    <StyledBox>
      <Container maxWidth="xxl">
        <Grid container spacing={8}>
          <Grid item lg={6} md={12} sm={12}>
            <Box className="PDSInfoSection">
              <Typography700 variant="h3" component="p">
                {content.promoDealTitle}
              </Typography700>
              <Typography variant="body1" component="p" className="PDSDesc" mb={1}>
                {content.promoDealDescription}
              </Typography>
              <NavigatorLink
                href={PATHS.motorcycleDeals.slug(
                  encodeURIComponent(content.PromoDealIdentifier),
                )}
>
                <Button variant="contained" color="primary">
                  {content.promoBtn}
                </Button>
              </NavigatorLink>
            </Box>
          </Grid>
          <Grid item lg={6} md={12} sm={12} className="PDSImageSide">
            <Box className="PDSImageContainer">
              <ImgBox
                image={{
                  src: getSizedImage(content.promoImage),
                  alt: content.promoDealTitle,
                }}
                width="100%"
                height="100%"
                unoptimized
        />
              <Box className="PDSSubImageContainer">
                <ImgBox
                  image={{
                    src: getSizedImage(content.promoSubImage),
                    alt: content.promoDealTitle,
                  }}
                  width="100%"
                  height="100%"
                  imgObjectFit="contain"
                  unoptimized
        />

              </Box>
            </Box>

          </Grid>
        </Grid>

      </Container>
    </StyledBox>
  );
};

export { PromotedDealSection };
